import {config} from '../constants/Constants';
import AxiosServices from './axios-service';
import {endpoints} from './api-end-points';

export class HomeServices {  

  ///---Headers for post request--///

  headers(){
    let obj = {
      'Authorization': 'Basic '+btoa(config.url.username+':'+config.url.password),
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    }
    return obj;
  }

  ///---Display polygons in all cities--///

  installPolygons(body){    
    const res = AxiosServices.post(endpoints.home.installPolygons, body, {headers : this.headers()});    
    return res;
  }

  ///---Display polygons in selected zone--///

  LoginCity(body){    
    const res = AxiosServices.post(endpoints.home.loginCity, body, {headers : this.headers()});    
    return res;
  }

}
const homeServices = new HomeServices();
export default homeServices;
